$(document).ready(function(){
  function refreshCartDrawer() {
    $('.cart-drawer__ship-prot').removeClass('loading');

    document.dispatchEvent(new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: {
        updated: true,
      }
    }));

    var TotalPrice = $('.cart_summary').attr('data-total-price');
    $('discount-progress-bar').attr('total-price', TotalPrice);
    $('.discount-bar__progress-bar').attr('data-total-price', TotalPrice);
    $('free-shipping-bar').attr('total-price', TotalPrice);
    
    // Update gift upsell after cart refresh - use longer delay to ensure DOM is updated
    setTimeout(updateGiftUpsellTitle, 200);
  }
  
  // ============================================
  // Gift Upsell Dynamic Title Update
  // ============================================
  
  function updateGiftUpsellTitle() {
    var $giftUpsell = $('.cart-drawer__gift-upsell');
    if ($giftUpsell.length === 0) return;
    
    // Quantity-based: unlock when cart has this many (non-gift) items
    var threshold = parseInt($giftUpsell.attr('data-gift-product-threshold'), 10) || 3;
    var cartProductCount = parseInt($giftUpsell.attr('data-cart-product-count'), 10) || 0;
    
    var $title = $giftUpsell.find('.gift-upsell__title');
    var $subtext = $giftUpsell.find('.gift-upsell__subtext');
    var $products = $giftUpsell.find('.gift-upsell__product');
    var $buttons = $giftUpsell.find('.gift-upsell__add-button');
    
    var isUnlocked = cartProductCount >= threshold;
    
    // Avoid flashing: only update title when we have a title element (e.g. after drawer content is replaced)
    if ($title.length === 0) return;
    
    if (isUnlocked) {
      // Unlocked state
      $title.html('Free Gift Unlocked!');
      $subtext.attr('hidden', 'hidden');
      $products.addClass('gift-upsell__product--unlocked');
      
      $buttons.each(function() {
        var $btn = $(this);
        var btn = $btn[0]; // Get the DOM element
        
        // Skip if button is currently in "Adding..." state
        if ($btn.attr('aria-busy') === 'true') {
          return;
        }
        
        // Remove ALL blocking states using both jQuery and native DOM
        btn.disabled = false;
        $btn.prop('disabled', false);
        $btn.removeAttr('disabled');
        $btn.removeAttr('aria-busy');
        $btn.removeClass('button--subdued');
        
        // Force pointer events and styles using both methods
        btn.style.pointerEvents = 'auto';
        btn.style.cursor = 'pointer';
        btn.style.opacity = '1';
        $btn.css({
          'pointer-events': 'auto',
          'cursor': 'pointer',
          'opacity': '1'
        });
        
        // Reset button text if not already adding
        if ($btn.text().trim() !== 'Adding...') {
          $btn.html('+ Add');
        }
        
        // Ensure the button has the click handler attached directly (for mobile)
        if (!btn.hasAttribute('data-click-bound')) {
          btn.setAttribute('data-click-bound', 'true');
          btn.addEventListener('click', function(e) {
            if (!this.disabled) {
              e.preventDefault();
              e.stopPropagation();
              window.addGiftToCart(this, e);
            }
          }, { passive: false });
        }
      });
    } else {
      // Locked state - show remaining items needed
      var remaining = threshold - cartProductCount;
      if (remaining < 0) remaining = 0;
      var productWord = remaining === 1 ? 'earplug' : 'earplugs';

      $title.html('Add <span class="gift-upsell__remaining">' + remaining + '</span> more ' + productWord + ' and get 1 free');
      $subtext.removeAttr('hidden');
      $products.removeClass('gift-upsell__product--unlocked');
      
      $buttons.each(function() {
        var $btn = $(this);
        var btn = $btn[0];
        
        btn.disabled = true;
        $btn.prop('disabled', true);
        $btn.attr('disabled', 'disabled');
        $btn.removeAttr('aria-busy');
        $btn.addClass('button--subdued');
        $btn.css({
          'pointer-events': 'none',
          'cursor': 'not-allowed'
        });
        $btn.html('+ Add');
      });
    }
    
    // Check if a "Free Gift" discount is applied (check cart line items for discount text)
    var hasFreeGiftDiscount = $giftUpsell.attr('data-has-free-gift-discount') === 'true';
    var giftsInCart = parseInt($giftUpsell.attr('data-gifts-in-cart'), 10) || 0;

    // Also check the DOM for any line item discount containing "Free Gift"
    $('.cart-drawer [class*="discount"], .cart-drawer [class*="badge"]').each(function() {
      var discountText = $(this).text().toLowerCase();
      if (discountText.indexOf('free gift') > -1) {
        hasFreeGiftDiscount = true;
        return false; // break the loop
      }
    });

    // Hide gift upsell when the free gift is already in cart OR when Free Gift discount is applied
    if (hasFreeGiftDiscount || giftsInCart > 0) {
      $giftUpsell.hide();
    } else {
      $giftUpsell.show();
    }
  }
  
  // Money formatter using Shopify's format
  function formatMoney(cents) {
    var $giftUpsell = $('.cart-drawer__gift-upsell');
    var moneyFormat = $giftUpsell.attr('data-money-format') || '€{{amount}}';
    
    // Handle zero decimal currencies
    var currencyCode = $giftUpsell.attr('data-currency-code') || 'EUR';
    var zeroDecimalCurrencies = ['CLP', 'COP', 'JPY', 'KRW', 'VND'];
    
    var amount;
    if (zeroDecimalCurrencies.indexOf(currencyCode) > -1) {
      amount = cents.toString();
    } else {
      // Always keep two decimal places for proper currency formatting (e.g., €1,60 not €1,6)
      amount = (cents / 100).toFixed(2);
    }
    
    // Add thousand separators for large numbers
    var amountWithSeparators = amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    
    // Replace the amount placeholder in the format string
    var formatted = moneyFormat
      .replace('{{amount}}', amountWithSeparators)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
    
    return formatted;
  }
  
  // Listen for cart refresh only - do NOT run on cart:change or we overwrite the title
  // with stale data (drawer updates innerHTML after a delay, so we'd show wrong text briefly).
  $(document).on('cart:refresh', function() {
    setTimeout(updateGiftUpsellTitle, 200);
  });
  
  // Do not run updateGiftUpsellTitle on generic cart AJAX (e.g. /cart/change.js) or we
  // overwrite the title with stale data before the drawer has replaced its content.


    function updateCartWithRetry(updates, retries = 3, delay = 3000) {
      $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: JSON.stringify({ updates }),
          contentType: "application/json",
          success: function(data) {
              console.log("Cart updated successfully:", data);
              refreshCartDrawer();
          },
          error: function(xhr) {
            refreshCartDrawer();
          }
      });
  }
  
  
    function initProtection() {
      jQuery.getJSON("/cart.js", function (cart) {
    
        
        var data_id = $('.shipping_protection__data-unit').attr('data-id');
        var data_qty = 0;

        var giftCard = $('.shipping_protection__data-unit').attr('data-gift-id');

        var otherItemsInCart = 0;
        var giftCard_qty = 0;

    
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].id == data_id) {
            data_qty += cart.items[i].quantity;
          }
          else if ( cart.items[i].id == giftCard ){
            giftCard_qty += cart.items[i].quantity;
          }
          else{
            otherItemsInCart += cart.items[i].quantity
          }
        }

        console.log(data_qty, giftCard_qty,  'SHIPPING PROTECTION', otherItemsInCart);
    
        if (cart.item_count > 0) {
          if (otherItemsInCart < 1 && data_qty > 0){

           updateCartWithRetry({ [data_id]: 0, [giftCard]: 0 });
          }
          if ($('.switch-pill_c').hasClass('disabled') ) {
            if (data_qty > 0) {

              updateCartWithRetry({ [data_id]: 0, [giftCard]: 0 });

            }
          }
          else {
            if (data_qty == 0) {
             

             updateCartWithRetry({ [data_id]: 1, [giftCard]: 1 });

              
            }
          }
        }
    
    
    
      });
    }
    
    function toggleSwitchDefault() {
      var position = $('.shipping_protection__data-unit').attr('data-protection');
      if (position == '0') {
          $('.switch-pill_c').removeClass('active');
          $('.switch-pill_c').addClass('disabled');
      }
      else {
          $('.switch-pill_c').addClass('active');
          $('.switch-pill_c').removeClass('disabled');
      }
     }

    $(document).on("click", ".switch-pill_c", function () {
      
      $('.cart-drawer__ship-prot').addClass('loading');
      
      if ($('.shipping_protection__data-unit').attr('data-protection') == '1') {
          $('.shipping_protection__data-unit').attr('data-protection', '0');
      }
      else {
        $('.shipping_protection__data-unit').attr('data-protection', '1');
      }
      
    });


  $(document).on("click",".link.line_item_to_remove",function() {
    var currentId = $(this).attr('data-id');
    var currentQty = 0;

    var key = $(this).attr('data-line-id');

    var data = {
            id: currentId,
            quantity: currentQty
        };


    $.ajax({
        url: '/cart/update.js',
        dataType: 'json',
        type: 'post',
        data: {
            updates: {
                [key]: 0
            }
        }
    }).then(res => {
         refreshCartDrawer();
    });
    
  });

  // ============================================
  // Gift Upsell Add to Cart Functionality
  // ============================================
  
  // Global function for inline onclick - more reliable on mobile
  window.addGiftToCart = function(button, e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) {
        e.stopImmediatePropagation();
      }
    }
    
    var $button = $(button);
    var btn = button;
    
    // Check if button is disabled (using both jQuery and native)
    if (btn.disabled || $button.prop('disabled') || $button.attr('aria-busy') === 'true') {
      console.log('Gift button is disabled or busy, ignoring click');
      return false;
    }
    
    // Prevent duplicate calls within 500ms
    if (btn.getAttribute('data-adding') === 'true') {
      console.log('Gift already being added, ignoring duplicate call');
      return false;
    }
    btn.setAttribute('data-adding', 'true');
    
    var variantId = $button.attr('data-variant-id');
    
    if (!variantId) {
      console.error('No variant ID found on gift button');
      return false;
    }
    
    console.log('Adding gift to cart, variant:', variantId);
    
    // Disable button and show loading state
    btn.disabled = true;
    $button.prop('disabled', true);
    $button.attr('aria-busy', 'true');
    $button.css('pointer-events', 'none');
    $button.text('Adding...');
    
    // Add to cart via AJAX
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1
      },
      dataType: 'json',
      success: function(response) {
        console.log('Gift added to cart:', response);
        
        // Clear adding flag
        btn.removeAttribute('data-adding');
        
        // Refresh the entire cart drawer to show the new line item
        // and update the gift upsell block state (will hide since gift is now in cart)
        refreshCartDrawer();
      },
      error: function(xhr, status, error) {
        console.error('Error adding gift to cart:', error);
        
        // Clear adding flag
        btn.removeAttribute('data-adding');
        
        // Reset button state on error
        btn.disabled = false;
        $button.prop('disabled', false);
        $button.removeAttr('aria-busy');
        $button.css({
          'pointer-events': 'auto',
          'cursor': 'pointer'
        });
        $button.text('+ Add');
        
        // Show error message
        alert('Could not add gift to cart. Please try again.');
      }
    });
    
    return false;
  };
  
  // jQuery event delegation as backup - use body for more reliable delegation
  $('body').on('click', '.gift-upsell__add-button:not([disabled])', function(e) {
    e.preventDefault();
    e.stopPropagation();
    window.addGiftToCart(this, e);
    return false;
  });
  
  // Also bind to the data attribute selector
  $('body').on('click', '[data-gift-add-button]:not([disabled])', function(e) {
    e.preventDefault();
    e.stopPropagation();
    window.addGiftToCart(this, e);
    return false;
  });
  
  // Mobile touchend fallback - some mobile browsers need this
  $('body').on('touchend', '.gift-upsell__add-button', function(e) {
    var $btn = $(this);
    var btn = this;
    
    // Check if button is actually disabled (attr returns undefined if not set)
    if (btn.disabled || $btn.prop('disabled') || $btn.attr('disabled') != null) {
      return; // Let it do nothing if disabled
    }
    
    // Prevent ghost clicks and double-firing
    if ($btn.attr('data-touch-handled') === 'true') {
      return false;
    }
    
    $btn.attr('data-touch-handled', 'true');
    setTimeout(function() {
      $btn.removeAttr('data-touch-handled');
    }, 300);
    
    e.preventDefault();
    e.stopPropagation();
    window.addGiftToCart(this, e);
    return false;
  });
  
  // Pointer events for modern mobile browsers
  document.addEventListener('pointerup', function(e) {
    var btn = e.target.closest('.gift-upsell__add-button');
    if (!btn) return;
    
    // Check if button is disabled
    if (btn.disabled || btn.getAttribute('disabled') != null) {
      return;
    }
    
    // Check if already handled
    if (btn.getAttribute('data-pointer-handled') === 'true') {
      return;
    }
    
    btn.setAttribute('data-pointer-handled', 'true');
    setTimeout(function() {
      btn.removeAttribute('data-pointer-handled');
    }, 300);
    
    e.preventDefault();
    e.stopPropagation();
    window.addGiftToCart(btn, e);
  }, { passive: false });
  
  // Initial update on page load
  setTimeout(updateGiftUpsellTitle, 300);
  
  // ============================================
  // MutationObserver to fix mobile button state
  // ============================================
  // This watches for when the cart drawer content is replaced (server refresh)
  // and re-applies the unlocked state to buttons if needed
  
  var giftUpsellObserver = null;
  
  function setupGiftUpsellObserver() {
    // Only set up once
    if (giftUpsellObserver) return;
    
    var cartDrawer = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer');
    if (!cartDrawer) {
      // Try again after DOM is ready
      setTimeout(setupGiftUpsellObserver, 500);
      return;
    }
    
    giftUpsellObserver = new MutationObserver(function(mutations) {
      var shouldUpdate = false;
      
      mutations.forEach(function(mutation) {
        // Check if gift upsell elements were added or modified
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check if this node contains gift upsell buttons
              if (node.classList && (
                  node.classList.contains('cart-drawer__gift-upsell') ||
                  node.classList.contains('gift-upsell__add-button')
              )) {
                shouldUpdate = true;
              }
              // Or if it contains gift upsell elements as children
              if (node.querySelector && node.querySelector('.gift-upsell__add-button')) {
                shouldUpdate = true;
              }
            }
          });
        }
      });
      
      if (shouldUpdate) {
        // Small delay to ensure DOM is fully settled
        setTimeout(updateGiftUpsellTitle, 50);
      }
    });
    
    // Observe the cart drawer for changes to its children/subtree
    giftUpsellObserver.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
    
    console.log('Gift upsell MutationObserver set up');
  }
  
  // Set up the observer when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupGiftUpsellObserver);
  } else {
    setupGiftUpsellObserver();
  }
  
});



